import BusinessIncome from "./BusinessIncome";

export default BusinessIncome;
